/** Параметр адреси «Записів і форм» з підсвіченим типом (routes.moduleSettings, прототип v4 cmFocus). */
const FOCUS = 'focus';

/**
 * Чи посилання меню `to` (шлях і, можливо, параметри) активне на поточній адресі: шлях збігається, і всі параметри посилання є в адресі з тими
 * самими значеннями; посилання без параметрів не активне, поки адреса підсвічує тип (`?focus=`) — тоді активний пункт цього типу (прототип:
 * «Записи й форми» лише без cmFocus). Чиста функція.
 */
export function menuLinkActive(to: string, pathname: string, search: string): boolean {
  const [path = '', query = ''] = to.split('?');
  if (path !== pathname) return false;
  const current = new URLSearchParams(search);
  const own = new URLSearchParams(query);
  if (!query) return !current.has(FOCUS);
  return [...own.entries()].every(([k, v]) => current.get(k) === v);
}
